import { routes } from '@constants';
import { Button, Image, theme, Typography } from '@styles';
import { number, string } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ActivityCard = ({ id, image, title, type }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const getTitle = () => {
    if (title) {
      return title;
    }
    switch (type) {
      case 'scenario':
        return i18n.t('Rank.Activities.Scenario');
      case 'card_form_activity':
        return i18n.t('Rank.Activities.Card');
      case 'test':
        return i18n.t('Rank.Activities.Test');
      default:
        return i18n.t('Rank.Activities.Activity');
    }
  };

  const handleNavigate = () => {
    switch (type) {
      case 'scenario':
        navigate(`${routes.activities}/${routes.scenario}`, {
          state: { exerciseId: id },
        });
        break;
      case 'card_form_activity':
        navigate(`${routes.activities}/${routes.cards}`, {
          state: { moduleId: id },
        });
        break;
      case 'test':
        navigate(`${routes.activities}/${routes.test}`, {
          state: { exerciseId: id },
        });
        break;
      default:
        break;
    }
  };

  return (
    <Button
      alignItems="flex-start"
      backgroundColor={theme.colors.white[10]}
      border={`1px solid ${theme.colors.whiteLine[100]}`}
      borderRadius={0}
      flexDirection="column"
      gap={16}
      height={240}
      justifyContent="flex-start"
      maxWidth={236}
      onClick={handleNavigate}
      p={16}
      width={236}
    >
      {image && (
        <Image
          height={110}
          src={image}
          style={{ objectFit: 'cover' }}
          width="100%"
        />
      )}
      <Typography
        color={theme.colors.white[100]}
        textAlign="left"
        variant="MS-semibold-s16-lh17"
      >
        {getTitle()}
      </Typography>
    </Button>
  );
};

ActivityCard.propTypes = {
  id: number.isRequired,
  image: string.isRequired,
  title: string.isRequired,
  type: string.isRequired,
};

export default ActivityCard;
